/* istanbul ignore file */
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { CustomBadge } from 'framework/ui/ui-builder';
import { DocuSignSignerStatus, DocuSignSignerStatusAlias } from '../docusignStatus';
import { ChipOwnProps } from '@mui/material';

const DocuSignSignerStatusBadge = ({ value: inputValue, source, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });
  const value = inputValue || getValue();
  const displayText = DocuSignSignerStatusAlias[value];

  const getColor = (): ChipOwnProps['color'] => {
    switch (value) {
      case DocuSignSignerStatus.COMPLETED:
        return 'success';
      case DocuSignSignerStatus.DECLINED:
        return 'error';
      case DocuSignSignerStatus.DELIVERED:
        return 'info';
      default:
        return 'default';
    }
  };

  return <CustomBadge text={displayText} color={getColor()} {...props} />;
};

export default DocuSignSignerStatusBadge;
